import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";

import { observable, action, toJS } from "mobx";
import {
    createStyles,
    withStyles,
    WithStyles,
    Theme,
} from "@material-ui/core/styles";
import { authStore } from "src/modules/auth";
import { observer } from "mobx-react";
import { withRouter } from 'react-router-dom';
import { permissionsStore } from '../admin/modules/Permissions';
import { BlockedPermission } from './';

@observer
class PortalRoute extends React.Component<any> {
    
    public render() {
        if (!authStore.loaded) {
            return <div>loading</div>
        }
        // console.log(toJS(authStore))
        if (!this.props.permission) {
            return (
                <Route path={this.props.path} component={this.props.component} />
            );
        }
        else if (authStore.currentUser.PermissionsList
            .filter((permission: any) => 
            permission.PermissionCategory === this.props.permission.PermissionCategory && 
            permission.PermissionType === this.props.permission.PermissionType).length > 0) {
            return (
                <Route path={this.props.path} component={this.props.component} />
            );
        }
        else {
            return (
                <Route path={this.props.path} component={BlockedPermission} />
            );
        }    
    }
}

export default withRouter(PortalRoute)



// WEBPACK FOOTER //
// ./src/modules/portal/PortalRoute.tsx